import { IonApp } from "@ionic/react";
import React from "react";

const IonicContainer: React.FC = ({ children }) => <IonApp>{children}</IonApp>;

export default IonicContainer;
